import { Badge } from '@/components/ui';
import { Send, XCircle } from 'lucide-react';


export function StatusBadge({ type }: { type: string}) {
  const style = styles[type as keyof typeof styles] || styles.failed;  
  const IconComponent = style.icon;
  const isAnimated = 'animate' in style && style.animate;
  return (
    <Badge className={`${style.color} flex items-center gap-1 w-fit`} variant={style.variant}>
      <IconComponent className={`h-3 w-3 ${isAnimated ? 'animate-spin' : ''}`} />
      {style.text}
    </Badge>
  );
}

const styles = {
  sent: {
    color: 'bg-green-100 text-green-800',
    icon: Send,
    text: 'Sent',
    variant: 'secondary' as const
  },

  failed: {
    color: 'bg-red-100 text-red-800',
    icon: XCircle,
    text: 'Failed',
    variant: 'destructive' as const
  },
}